import { Injectable } from '@angular/core';
import { RestService } from './rest.service';

@Injectable({
  providedIn: 'root'
})
export class AgileStudioAuthService {

  constructor(public rest: RestService) { }

  public agileStudioAuthToken(username: string, password: string) {
    let apiBody = {
      "code": "",
      "agileUserName":username,
      "agilePassword":password,
      "project_management_type": "agileStudio",
      "baseUrl": ""
    }
    return this.rest.post('addProjectManagementUser', apiBody, null);
  }

  public isAgileStudioIntegrationAvailable() {
    return this.rest.get('checkProjectManagementIntegrationStatus', "agileStudio", null)
  }
}
